export const paymentStates = {
  INIT: "init",
  INIT_LOADING: "init_loading",
  INIT_FAILURE: "init_failure",
  SOLD_OUT: "sold_out",
  PROCESSING: "processing",
  INITIATED: "initiated",
  SUCCESS: "success",
  FAILED: "failed",
  PENDING: "pending",
};
export const DECLINE_CODES = [
  "live_mode_test_card",
  "do_not_honor",
  "generic_decline",
  "insufficient_funds",
  "transaction_not_allowed",
  "testmode_decline",
  "incorrect_number",
  "expired_card",
];
export const FORM_KEYS = {
  BOOK_FORM: "BOOK_FORM",
  PAYMENT_BOOKING_DETAILS: "PAYMENT_FORM_DETAILS",
  PAYMENT_DETAILS: "PAYMENT_DETAILS",
  PAYMENT_ACCOMODATION_DETAILS: "PAYMENT_ACCOMODATION_DETAILS",
  PAYMENT_INVENTORY_DETAILS: "PAYMENT_INVENTORY_DETAILS",
  PAYMENT_INITIATED: "PAYMENT_INITIATED",
  SHOW_NPS_CARD: "SHOW_NPS_CARD",
  SHOW_NPS_CARD_FINAL_SCREEN: "SHOW_NPS_CARD_FINAL_SCREEN",
  PAYMENT_DECLINE: "PAYMENT_DECLINE",
  PAYMENT_CARD_INFO: "PAYMENT_CARD_INFO",
};
export const CONTACT_MAIL = "contact@amberstudent.com";
export const CONTACT_NUMBER = "+91 8035735724";
